import { redirect } from 'react-router-dom';
import { useApplicationStore } from '@data';

export default async function createPasswordLoader(): Promise<Response | null> {
  const { verificationToken } = useApplicationStore.getState();

  if (!verificationToken) {
    return redirect('/services');
  }

  return null;
}
